module.exports = __webpack_public_path__ + "static/statesman_sec3-6e6a556aefe9e8f21178853d79bdc503.png";